import Axios from 'axios'

import { SERVER_BASE_URL } from './baseUrl'

export const createChat = async (token: string, firstEmail: string, secondEmail: string) => {
  try {
    const response = await Axios.post(
      `${SERVER_BASE_URL}api/chats`,
      {
        firstEmail,
        secondEmail,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête createChat:', error)
    throw error
  }
}

export const getChatsByUser = async (token: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/chat`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête getChatsByUser:', error)
    throw error
  }
}

export const deleteChat = async (token: string, chatId: string) => {
  try {
    const response = await Axios.delete(`${SERVER_BASE_URL}api/chats/${chatId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête deleteChat:', error)
    throw error
  }
}

export const setStatusChat = async (token: string, chatId: string, status: number) => {
  try {
    const response = await Axios.put(
      `${SERVER_BASE_URL}api/chat/${chatId}`,
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête setStatusChat:', error)
    throw error
  }
}

export const getChatByVisiteId = async (token: string, visiteId: string) => {
  try {
    const response = await Axios.get(`${SERVER_BASE_URL}api/chat/visiteid/${visiteId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    return response.data
  } catch (error) {
    console.error('Erreur lors de la requête getChatByVisiteId:', error)
    throw error
  }
}
